/**
 * Whether Picks should show the "No rounds available" empty state.
 * Require the loaded league to match the selection so a league switch never
 * flashes empty while prior roundsData is cleared / next fetch is in flight.
 */
export function shouldShowNoRoundsAvailable({
  loading,
  hasRounds,
  loadedLeagueCode,
  selectedLeagueCode
}) {
  return (
    !loading &&
    !hasRounds &&
    loadedLeagueCode != null &&
    loadedLeagueCode === selectedLeagueCode
  );
}
